export default {
  ReportsPage: {
    reports: 'Reports',
  },
  ReportsTabs: {
    donors: 'Donors',
    donations: 'Donations',
    products: 'Products',
    owners: 'Owners',
    ineligibles: 'Ineligible Participants',
  },
  ReportDownloads: {
    downloadCsv: 'Download CSV',
    downloadExcel: 'Download Excel',
  },
  ReportFilters: {
    clearFilters: 'Clear filters',
    from: 'From',
    to: 'To',
    rowsShown: '{{shown}} of {{total}} rows',
  },
  DonorsReportsCsvLink: {
    downloadReport: 'Download report',
  },
  DonorReports: {
    generateCsvReport: 'Generate donors report',
    id: 'ID',
    shortId: 'Short ID',
    name: 'Name',
    ownerLastName: 'Owner last name',
    ownerId: 'Owner ID',
    location: 'Location',
    region: 'Region',
    requiresAppointment: 'Requires appointment',
    species: 'Species',
    breed: 'Breed',
    color: 'Color',
    gender: 'Gender',
    age: 'Age',
    weight: 'Weight',
    neutered: 'Neutered',
    bloodType: 'Blood type',
    status: 'Status',
    excludeStatuses: 'Exclude statuses',
    registrationDate: 'Registration date',
    rabiesDate: 'Rabies date',
    distemperDate: 'Distemper date',
    retiredDate: 'Retired date',
    nextDonationDate: 'Next donation date',
    labWorkDue: 'LabWork due',
    dvmExamDue: 'DVM exam due',
    primaryVeterinarian: 'Primary veterinarian',
    dvmExamPerformedBy: 'DVM exam performed by',
    microchipNumber: 'Microchip number',
    totalCollected: 'Total collected',
    approvedDonationMl: 'Donation approved volume (ml)',
    donationMLApprovedAmount: 'Donation (ml) approved amount',
    donationFrequency: 'Donation frequency',
    acceptSimparicaTrio: 'Accept simparica trio',
    notes: 'Notes',
    retiredReason: 'Retired reason',
    retiredReasonComment: 'Retired reason comment',
    emptyReport: 'No records available to generate the report',
  },
  DonationReports: {
    generateCsvReport: 'Generate donations report',
    id: 'ID',
    shortId: 'Short ID',
    temperature: 'Temperature',
    pulse: 'Pulse',
    respiration: 'Respiration',
    capillaryRefillTime: 'Capillary refill time',
    mucousMembrane: 'Mucous membrane',
    packedCellVolume: 'Packed cell volume',
    totalSolids: 'Total solids',
    weight: 'Weight',
    working: 'Working',
    unit: 'Unit',
    actual: 'Actual',
    approvedDonationsMl: 'Approved donations (ml)',
    donationDate: 'Donation date',
    donationNumber: 'Donation number',
    failedReason: 'Failed reason',
    jugularVein: 'Jugular vein',
    ineligibleReason: 'Ineligible reason',
    additionalInfoId: 'Additional info ID',
    numberOfCollectionUnitsUsed: 'Number of collection units used',
    primaryHolderFirstName: 'Primary holder first name',
    primaryHolderLastName: 'Primary holder last name',
    pokerFirstName: 'Poker first name',
    pokerLastName: 'Poker last name',
    donorId: 'Donor ID',
    donorFirstName: 'Donor first name',
    donorLastName: 'Donor last name',
    donorLocation: 'Donor location',
    donorRegion: 'Donor region',
    comment: 'Comment',
    emptyReport: 'No records available to generate the report',
  },
  OwnerReports: {
    generateCsvReport: 'Generate owners report',
    id: 'ID',
    shortId: 'Short ID',
    email: 'Email',
    firstName: 'First name',
    lastName: 'Last name',
    phoneNumber: 'Phone number',
    streetAddress: 'Street address',
    city: 'City',
    state: 'State',
    zipCode: 'Zip code',
    locationPreferences: 'Location preferences',
    regions: 'Region',
    regionPreferences: 'Region preferences',
    type: 'Type',
    isArchived: 'Is archived',
    contactPreferences: 'Contact preferences',
    birthday: 'Birthday date',
    donors: 'Donors',
    emptyReport: 'No records available to generate the report',
  },
  ProductReports: {
    generateCsvReport: 'Generate products report',
    mantelAssignedOnly: 'Mantel assigned only',
    id: 'ID',
    shortId: 'Short ID',
    createdAt: 'Created at',
    donationId: 'Donation ID',
    approvedDonationsMl: 'Approved donation volume (ml)',
    actualCollectionVolumeMl: 'Actual collection volume (ml)',
    donorFirstName: 'Donor first name',
    donorLastName: 'Donor last name',
    donorLocation: 'Donor location',
    bloodType: 'Blood type',
    poker: 'Poker',
    primaryHolder: 'Primary holder',
    anticoagulant: 'Anticoagulant',
    expirationDate: 'Expiration date',
    status: 'Status',
    storageRequirements: 'Storage requirements',
    value: 'Volume (ml)',
    woocommerceCategoryId: 'WooCommerce category ID',
    woocommerceProductId: 'WooCommerce product ID',
    productCategoryName: 'Product category name',
    productRegion: 'Region',
    discarded: 'Discarded',
    processor: 'Processor',
    processorId: 'Processor ID',
    discardedProcessingType: 'Discarded processing type',
    discardedReason: 'Discard reason',
    discardedNotes: 'Discard notes',
    emptyReport: 'No records available to generate the report',
    respin: 'Respin',
  },
  IneligiblesReports: {
    generateCsvReport: 'Generate ineligible participants report',
    id: 'ID',
    createdAt: 'Created at',
    ownerEmail: 'Owner email',
    ownerFirstName: 'Owner first name',
    ownerLastName: 'Owner last name',
    ownerPhoneNumber: 'Owner phone number',
    contactPreferences: 'Contact preferences',
    locationPreferences: 'Location preferences',
    donorName: 'Donor name',
    donorAge: 'Donor age',
    donorSpecies: 'Donor species',
    donorGender: 'Donor gender',
    donorWeight: 'Donor weight',
    donorLocation: 'Donor location',
    neutered: 'Neutered',
    hasTransfusion: 'Has transfusion',
    takeMedications: 'Take medications',
    medicationCourse: 'Medication course',
    primaryVeterinarian: 'Primary veterinarian',
    hasMicrochip: 'Has microchip',
    microchipNumber: 'Microchip number',
    distinguishableMarks: 'Distinguishable marks',
    hasHeartMurmur: 'Has heart murmur',
    emptyReport: 'No records available to generate the report',
  },
};
